<template>
  <LcModal
    :close-triggers="['click-outside', 'close-button', 'escape']"
    full-screen
    full-size
    :tracking="{
      action: 'ask_for_help',
      topicKey: 'quidget-ai-chat-bot',
    }"
    transition="fade"
    @close="emit('close')"
  >
    <template #modal="{ setRef }">
      <LcCard
        :ref="setRef"
        :body-class="[$style['card-body'], 'px-none py-none']"
        :class="$style.card"
      >
        <div class="h-full w-full">
          <div :class="$style['card-loading']">
            <ShamrockSpinner />
          </div>

          <iframe
            id="widget-container"
            :class="$style['card-widget']"
            :src="QUIDGET_AI_IFRAME_SRC"
            :title="$t('quidgetaimodal.iframe.title')"
          />
        </div>

        <div :class="[$style['card-cta'], 'flex items-center justify-center']">
          <LcButton
            :class="[$style['card-close'], 'w-full mx-100']"
            no-padding
            size="small"
            variant="tertiary"
            @click="emit('close')"
          >
            {{ $t('quidgetaimodal.cta.close') }}
          </LcButton>
        </div>
      </LcCard>
    </template>
  </LcModal>
</template>

<script lang="ts" setup>
type QuidgetAiModalEmits = { (event: 'close'): void }

const DATA_ID = 'c242eb4e-fd0b-443d-9ae6-a0b63870ea81'
const QUIDGET_AI_IFRAME_SRC = `https://quidget.ai/webchat/chat-iframe.html?id=${DATA_ID}`

useHead({
  script: [
    {
      'async': true,
      ['data-id']: DATA_ID,
      ['data-options']: JSON.stringify({ chatView: 'permanent' }),
      ['data-target']: 'widget-container',
      'src': 'https://quidget.ai/webchat/quidget.loader.js',
    },
  ],
})

const emit = defineEmits<QuidgetAiModalEmits>()
</script>

<style lang="scss" module>
.card {
  width: 100%;
  border-radius: token('size/radius/none');

  @include media-desktop {
    width: unset;
    border-radius: token('size/radius/l');
  }

  &-body {
    width: 100%;
    height: 100vh;

    @include media-desktop {
      width: 100vw;
      max-width: 31.25rem;
      max-height: 50rem;
    }
  }

  &-widget {
    position: absolute;
    width: 100%;
    height: calc(100% - 2.5rem);
    border: none;
  }

  &-cta {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    height: 3.75rem;
  }

  &-loading {
    position: absolute;
    inset: 0;
  }

  &-close {
    z-index: 2;
  }
}
</style>

<style lang="scss">
.quidget {
  transition-property: none !important;

  &-wrap {
    border-radius: token('size/radius/none') !important;
    animation: none !important;

    .q-header {
      border-radius: token('size/radius/none');
    }

    @include media-desktop {
      border-top-left-radius: token('size/radius/m') !important;
      border-top-right-radius: token('size/radius/m') !important;
    }
  }

  /* stylelint-disable-next-line selector-class-pattern */
  .q-home-header__main {
    background-color: var(--lc-color);
  }
}
</style>
